<script setup lang="ts">
import { computed, onMounted, watch, provide } from 'vue'
import { useRoute } from 'vue-router'
import { useDashboards } from '@/stores/dashboards'
import { handleError } from '@/lib/error'
import Home from '@/views/Home.vue'
import Dashboard from '@/views/Dashboard.vue'

const route = useRoute()
const dashboards = useDashboards()

const organizationId = computed(() => route.params['orgId'] as string)

// Provide organization ID for preview mode (used by Home.vue)
provide('previewOrganizationId', organizationId)
const dashboardId = computed(() => route.params.id as string | undefined)

// Fetch preview dashboards when organization ID changes
watch(
  () => organizationId.value,
  async (orgId) => {
    if (orgId) {
      try {
        await dashboards.fetchPreviewDashboards(orgId)
      } catch (error) {
        handleError(error, 'Failed to load preview dashboards')
      }
    }
  },
  { immediate: true },
)

onMounted(async () => {
  if (organizationId.value) {
    try {
      await dashboards.fetchPreviewDashboards(organizationId.value)
    } catch (error) {
      handleError(error, 'Failed to load preview dashboards')
    }
  }
})
</script>

<template>
  <Home v-if="!dashboardId" />
  <Dashboard v-else />
</template>
